import Vue, {PluginObject, VueConstructor} from "vue";
import Cipher from "./src/Cipher";
import BrowserStorage from "./src/BrowserStorage";
import OAuth2, {OAuth2Configuration} from "./src/OAuth2";
import HttpService from "./src/HttpService";
import * as Cookies from "js-cookie";

export type GvamPluginOptions = {
  oAuth2Configuration: OAuth2Configuration;
  cipherKey: string;
};

const GvamVuePlugin: PluginObject<GvamPluginOptions> = {
    install: (vue: VueConstructor<Vue>, options?: GvamPluginOptions) => {

        if (options === undefined) {
            throw new Error('Configuration not defined');
        }
        Vue.prototype.$browserStorage = new BrowserStorage(
            new Cipher(options.cipherKey),
            Cookies
        );
        Vue.prototype.$httpService = new HttpService();
        Vue.prototype.$oAuth2 = new OAuth2(
            options.oAuth2Configuration,
            Vue.prototype.$httpService,
            Vue.prototype.$browserStorage,
        );
    }
};

export default GvamVuePlugin;